import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MovimentiMagazzino, PostMovimentiMagazzinoMatricola } from 'src/app/models/movimenti-magazzino';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MovimentiMagazzinoService {
  private http = inject(HttpClient);


  mmUrl = environment.ildatoArticoliDpi + 'api/movimentimagazzino';

  list(): Observable<MovimentiMagazzino[]> {
    return this.http.get<MovimentiMagazzino[]>(`${this.mmUrl}`);
  }

  listByArticolo(idArticolo: number): Observable<MovimentiMagazzino[]> {
    let filterString = '';
    if (idArticolo) {
      filterString += 'IdArticolo=' + idArticolo + '&';
    }
   
    if (filterString.length > 0) {
      filterString = '?' + filterString.slice(0, -1).trim();
    }
    return this.http.get<MovimentiMagazzino[]>(`${this.mmUrl}${ filterString}`);
  }

  giacenzeProgressive(idArticolo: number, daData: Date, aData: Date): Observable<any[]> {
    const daDataStr = daData.getFullYear() + '-' + (daData.getMonth() + 1) + '-' + daData.getDate();
    const aDataStr = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate();
    return this.http.get<any[]>(this.mmUrl + '/giacenzeProgressive/' + idArticolo + '/' + daDataStr + '/' + aDataStr);
  }

  consegneMensili(anno:number,idArticolo: number): Observable<any[]> {
    let filterString = '';
    if (idArticolo) {
      filterString += 'IdArticolo=' + idArticolo + '&';
    }
    if (filterString.length > 0) {
      filterString = '?' + filterString.slice(0, -1).trim();
    }
    return this.http.get<any[]>(this.mmUrl + '/datiGraficiConsegneMensili/' +  anno + filterString);
  }



  get(id: number): Observable<MovimentiMagazzino> {
    return this.http.get<MovimentiMagazzino>(`${this.mmUrl}/${id}`);
  }

  post(values: MovimentiMagazzino): Observable<MovimentiMagazzino> {
    return this.http.post<MovimentiMagazzino>(`${this.mmUrl}`, values);
  }

  postMovMagMatricole(values: PostMovimentiMagazzinoMatricola): Observable<MovimentiMagazzino> {
    return this.http.post<MovimentiMagazzino>(`${this.mmUrl + '/matricola'}`, values);
  }

  update(key: number, values: MovimentiMagazzino): Observable<MovimentiMagazzino> {
    return this.http.put<MovimentiMagazzino>(`${this.mmUrl}/${key}`, values);
  }

  remove(key: number): Observable<MovimentiMagazzino> {
    return this.http.delete<MovimentiMagazzino>(`${this.mmUrl}/${key}`);
  }
}
